import vars from '../globals';

const $button = $('.product-play-button');
const $buttonMobile = $('.product-bottom-bar__selector');
const $buttonText = $('.product-text__selector');
const $paragraphs = $('.product-text--audio');
const $cites = $('.product-cite');
const $bottomBar = $('.product-bottom-bar');

let trackID = false;
let backgroundID = 1;

const isTrackLoad = ($paragraph) => {
	let $track = $paragraph.find('.product-text__track');

	if ($track[0].readyState !== 4 && !$track.hasClass('isLoaded')) {
		$track[0].load();
		$track.addClass('isLoaded');
	}
};

const getAudioID = (id) => {
	if (id !== trackID) {
		trackID = id;
	}
};

const getParagraphStatus = () => {
	let result = false;

	$paragraphs.each((i, paragraph) => {
		let $paragraph = $(paragraph);

		if ($paragraph.hasClass('isActive')) {
			result = true;
		}
	});

	return result;
};

const toggleShownButton = () => {
	if ($cites.filter($('.isActive')).length > 0) {
		$button.removeClass('isShown');
	} else {
		$button.addClass('isShown');
	}
};

const checkPlayButton = () => {
	let $buttonRing = $('.product-play-button__ring');
	let $cite = $('.product-cite--3');
	let citeTop = $cite.offset().top;

	let scrollTop = $buttonRing.offset().top;
	let buttonHeight = $buttonRing.height();

	if (scrollTop + buttonHeight >= citeTop) {
		$cite.addClass('isActive');
	} else {
		$cite.removeClass('isActive');
	}

	toggleShownButton();
};

const setActiveParagraph = () => {
	$paragraphs.each((i, paragraph) => {
		let $paragraph = $(paragraph);
		let paragraphTop = $paragraph.offset().top;
		let paragraphHeight = $paragraph.height();

		let scrollTop = $button.offset().top;
		let buttonHeight = $button.height();

		if (scrollTop >= paragraphTop && scrollTop + buttonHeight <= paragraphTop + paragraphHeight) {
			$paragraph.addClass('isActive');

			getAudioID($paragraph.data('audio'));
			isTrackLoad($paragraph);
		} else {
			$paragraph.removeClass('isActive');
		}
	});
};

const setActiveParagraphMobile = () => {
	const $selectors = $('.product-text__selector');

	$selectors.each((i, selector) => {
		let $selector = $(selector);
		let selectorTop = $selector.offset().top;
		let selectorHeight = $selector.height();

		let scrollTop = window.pageYOffset;
		let scrollTopHeight = scrollTop + window.innerHeight;

		const $paragraph = $selector.closest('.product-text--audio');

		if (scrollTopHeight >= selectorTop && selectorTop + selectorHeight >= scrollTop) {
			$paragraph.addClass('isActive');

			getAudioID($paragraph.data('audio'));
			isTrackLoad($paragraph);
		} else {
			$paragraph.removeClass('isActive');
		}
	});
};

const setStickButton = (e) => {
	let $currentItem = $(e.currentTarget);

	let windowHeight = vars.$window.height();

	let offsetTop = $('.product-content').offset().top;

	if ($currentItem.scrollTop() >= offsetTop - windowHeight / 2 + $button.height() / 2 && offsetTop !== 0) {
		$button.addClass('isFixed');
	} else {
		$button.removeClass('isFixed');
	}
};

const setBottomBarStatus = () => {
	if (getParagraphStatus()) {
		$bottomBar.addClass('isActive');
	} else {
		$bottomBar.removeClass('isActive');
	}
};

const playTrack = () => {
	const $tracks = $('.product-text__track').not(`.product-text__track--${trackID}`);
	const $track = $(`.product-text__track--${trackID}`);
	const $paragraph = $track.closest('.product-text');

	$tracks.each((i, track) => {
		let $track = $(track); //eslint-disable-line

		if ($track.hasClass('isPlayed')) {
			$track.removeClass('isPlayed');

			$track[0].pause();
		}
	});

	$track.addClass('isPlayed');
	$paragraph.addClass('isPlayed');

	$track[0].play();
};

const togglePlayedButton = () => {
	if (!$button.hasClass('isPlayed')) {
		playTrack();

		vars.$html.data('product-background', backgroundID).attr('data-product-background', backgroundID);

		backgroundID++;

		if (backgroundID > 3) {
			backgroundID = 1;
		}

		vars.$document.trigger('product-audio-play');
	} else {
		const $track = $('.product-text__track.isPlayed');
		const $paragraph = $('.product-text.isPlayed');

		$track[0].pause();

		vars.$html.data('product-background', 0).attr('data-product-background', 0);

		$track.removeClass('isPlayed');
		$paragraph.removeClass('isPlayed');
	}

	$button.toggleClass('isPlayed');
};

const togglePlayedButtonMobile = () => {
	if (!$bottomBar.hasClass('isPlayed')) {
		playTrack();
		vars.$document.trigger('product-audio-play');
	} else {
		const $track = $('.product-text__track.isPlayed');
		const $paragraph = $('.product-text.isPlayed');

		$track[0].pause();

		$track.removeClass('isPlayed');
		$paragraph.removeClass('isPlayed');
	}

	$bottomBar.toggleClass('isPlayed');
};

$button.on('click', () => {
	togglePlayedButton();
});

$buttonText.on('click', (e) => {
	let $paragraph = $(e.currentTarget).closest('.product-text');

	if (!$paragraph.hasClass('isPlayed') && !vars.isMobile()) {
		if ($button.hasClass('isPlayed')) {
			togglePlayedButton();
			getAudioID($paragraph.data('audio'));
			togglePlayedButton();
		} else {
			togglePlayedButton();
		}
	} else if (!$paragraph.hasClass('isPlayed') && vars.isMobile()) {
		if ($bottomBar.hasClass('isPlayed')) {
			togglePlayedButtonMobile();
			getAudioID($paragraph.data('audio'));
			togglePlayedButtonMobile();
		} else {
			togglePlayedButtonMobile();
		}
	} else if ($paragraph.hasClass('isPlayed') && !vars.isMobile()) {
		if ($button.hasClass('isPlayed')) {
			togglePlayedButton();
		} else {
			togglePlayedButton();
			getAudioID($paragraph.data('audio'));
			togglePlayedButton();
		}
	} else if ($paragraph.hasClass('isPlayed') && vars.isMobile()) {
		if ($bottomBar.hasClass('isPlayed')) {
			togglePlayedButtonMobile();
		} else {
			togglePlayedButtonMobile();
			getAudioID($paragraph.data('audio'));
			togglePlayedButtonMobile();
		}
	}
});

$buttonMobile.on('click', () => {
	togglePlayedButtonMobile();
});

$(window).on('resize scroll', (e) => {
	if (vars.isMobile()) {
		setActiveParagraphMobile();
		setBottomBarStatus();
	} else {
		setStickButton(e);
		setActiveParagraph();
		checkPlayButton();
	}
});

setTimeout(() => {
	const $tracks = $('.product-text__track');

	$tracks.each((i, track) => {
		let $track = $(track);

		track.addEventListener('ended', () => {
			$track[0].pause();

			if (vars.isMobile()) {
				$bottomBar.removeClass('isPlayed');
			} else {
				$button.removeClass('isPlayed');
				vars.$html.data('product-background', 0).attr('data-product-background', 0);
			}

			track.currentTime = 0;
		});
	});
}, 300);

export const productAudioInit = () => {
	if (vars.isMobile()) {
		setActiveParagraphMobile();
	} else {
		setActiveParagraph();
	}
};

export const productAudioDestroy = () => {
	const $tracks = $('.product-text__track');

	$tracks.each((i, track) => {
		let $track = $(track); //eslint-disable-line

		if ($track.hasClass('isPlayed')) {
			$track.removeClass('isPlayed');

			$track[0].pause();
			$track[0].currentTime = 0;
		}
	});

	$paragraphs.each((i, paragraph) => {
		let $paragraph = $(paragraph);

		$paragraph.removeClass('isActive');
	});

	trackID = false;

	if (vars.isMobile()) {
		$bottomBar.removeClass('isActive');
		$bottomBar.removeClass('isPlayed');
	} else {
		$button.removeClass('isPlayed');
		backgroundID = 1;
		vars.$html.data('product-background', 0).attr('data-product-background', 0);
	}
};
